import type { GenieKnowledgeEntry } from '../../types';

export const lambertEaton: GenieKnowledgeEntry = {
  id: 'lambert_eaton',
  name: 'Síndrome de Lambert-Eaton (LEMS)',
  category: 'unm',
  conversation: {
    headline:
      'Trastorno presináptico de la unión neuromuscular. Incremento del CMAP tras ejercicio breve (>60%).',
    edxHighlights: [
      'CMAP basal reducido con incremento >60% tras 10 s de ejercicio',
      'RNS a 2–3 Hz: decremento inicial, luego incremento a alta frecuencia',
      'PAUMs de baja amplitud (<1 mV) con incremento tras activación',
      'Asociación con cáncer de pulmón células pequeñas en ~50%',
    ],
    pearls: [
      'Facilitación post-ejercicio es patognomónica — realizar siempre si hay sospecha.',
      'Debilidad proximal de cadera + autonomía (boca seca) orientan a LEMS.',
    ],
    differentials: [
      { name: 'Miastenia Gravis', distinguishingHint: 'decremento RNS sin facilitación; postsináptico' },
      { name: 'Miopatía', distinguishingHint: 'PAUMs miopáticos, sin respuesta a ejercicio en CMAP' },
    ],
    nextSteps: [
      'Facilitación del CMAP tras ejercicio en EDB o ADM',
      'Anti-VGCC (P/Q-type); TAC de tórax si paraneoplásico',
    ],
  },
  relatedTiebreakers: ['mg_vs_lems'],
  orientationHints: {
    whenToSuspect: 'Debilidad proximal + autonomía + fatigabilidad; sospecha paraneoplásica',
  },
};
